import exoEventBus from './exoEventBus'

export default exoEventBus